import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export default function KPITotalReelsListItem(props){
    return (
        <TableRow>
            <TableCell sx={{fontWeight:'normal'}}>{props.data.prodName} ({props.data.prodNum})</TableCell>
            <TableCell align="right" sx={{width:"75px", fontWeight:'normal'}}>{new Intl.NumberFormat('en-US').format(props.data.amount12.toFixed(2))}%</TableCell>
            <TableCell align="right" sx={{width:"75px", fontWeight:'normal'}}>{new Intl.NumberFormat('en-US').format(props.data.amount6.toFixed(2))}%</TableCell>
        </TableRow>
    )
}

